import { FC, useState, useCallback } from 'react';
import cn from 'classnames';

import useNotification from '../../../../core/hooks/useNotification';
import { contactUs } from '../../../../core/apiHooks/useContactUs';

import './NoAiSearchAccess.styles.scss';

const NoAiSearchAccess: FC = () => {
    const { addNotification } = useNotification();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [hasContacted, setHasContacted] = useState(false);

    const handleContactClick = useCallback(
        async (e: React.MouseEvent<HTMLAnchorElement>) => {
            e.preventDefault();
            if (isSubmitting || hasContacted) {
                return;
            }
            setIsSubmitting(true);
            try {
                await contactUs();
                addNotification({
                    message: <span>Your request has been sent. We’ll contact you about Generative AI search access.</span>,
                    status: 'success'
                });

                setHasContacted(true);
            } catch (err) {
                addNotification({
                    message: <span>Something went wrong...</span>,
                    status: 'error'
                });
            } finally {
                setIsSubmitting(false);
            }
        },
        [isSubmitting, addNotification, hasContacted]
    );

    return (
        <div className="NoAiSearchAccess" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/blurred_ai_bg.webp)` }}>
            <div className="NoAiSearchAccess__notice">
                <div className="NoAiSearchAccess__text">
                    Want access to generative AI search? Contact your Account Manager now to unlock this exclusive
                    <div>
                        <strong>Datassential One</strong> feature!
                    </div>
                </div>
                <div className={cn('NoAiSearchAccess__link', { 'is-disabled': hasContacted })}>
                    <a
                        href="mailto:support@datassential.com"
                        onClick={handleContactClick}
                        aria-disabled={isSubmitting || hasContacted}
                    >
                        Contact us
                    </a>{' '}
                    now
                </div>
            </div>
        </div>
    );
};

export default NoAiSearchAccess;
